import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import './HomePage.css';
import { IngredientSlide } from '../IngredientSlide';
import { IngredientName } from '../IngredientName';
import { IngredientRow } from '../IngredientRow';
import { Spinner } from '../Spinner';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { extractHostname } from '../_helpers';
import Modal from 'react-modal';

import { userActions, cocktailActions, alertActions } from '../_actions';
import { RecipeCategory } from '../RecipeCategory';
import { ConfirmClearData } from '../ConfirmClearData';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    fontSize              : '150%',
    padding: 0
  },
  overlay: {zIndex: 1000}
};

class HomePage extends React.Component {
  constructor(props) {
    super(props);

    // begin modal
    this.state = {
      modalIsOpen: false,
      selected_name: ''
    };

    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    // end modal

    const {user} = this.props;

    this.state = {
      userModified: {
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        cabinet: user.cabinet,
        favorites: user.favorites ? user.favorites : [],
        keyIngredients: user.keyIngredients ? user.keyIngredients : [],
        access_level: user.access_level,
        _id: user._id
      },
      submitted: false,
      storeShelves: [],
      shoppingList: [],
      keyIngredients: []
    };

    this.onItemClick = this.onItemClick.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ingredients.items) {
      const toDelete = new Set(nextProps.user.cabinet);
      const storeShelves = nextProps.ingredients.items.filter(ingredientItem => !toDelete.has(ingredientItem.machine_name));

      var img_urls = [];
      var len = storeShelves.length;
      for (var i = 0; i < len; i++) {
        img_urls.push(storeShelves[i].img_url);
      }

      this.setState({
        storeShelves,
        img_urls
      })
    }
    if (nextProps.user) {
      this.setState({
        userModified: {
          first_name: nextProps.user.first_name,
          last_name: nextProps.user.last_name,
          email: nextProps.user.email,
          cabinet: nextProps.user.cabinet,
          favorites: nextProps.user.favorites ? nextProps.user.favorites : [],
          keyIngredients: nextProps.user.keyIngredients ? nextProps.user.keyIngredients : [],
          access_level: nextProps.user.access_level,
          _id: nextProps.user._id
        }
      });
      //this.props.dispatch(cocktailActions.getMyRecipes(nextProps.user.cabinet, nextProps.user.keyIngredients));

    }
  }

  componentDidMount() {
    this.props.dispatch(cocktailActions.getAllIngredients());
    this.props.dispatch(cocktailActions.getMyRecipes(this.state.userModified.cabinet, this.state.userModified.keyIngredients));
  }

  onItemClick(machine_name) {

    const {userModified} = this.state;

    let joined = userModified.cabinet.concat(machine_name);

    let userModifiedNew = {
      ...userModified,
      ['cabinet']: joined
    };
    this.setState({
      //selectedItem: machine_name,
      userModified: userModifiedNew,
      submitted: true
    });

    const {dispatch} = this.props;
    dispatch(userActions.update(userModifiedNew, false, `${machine_name.replace(/_/g, ' ').capitalize()} added to your bar!`));
    dispatch(cocktailActions.getMyRecipes(userModifiedNew.cabinet, userModifiedNew.keyIngredients));
  }

  // begin modal
  openModal(recipe, img_url) {
    if (recipe.name) {
      this.setState({
        modalIsOpen: true,
        selected_machine_name: recipe.machine_name,
        selected_name: recipe.name,
        selected_url: recipe.recipe_url,
        selected_domain: extractHostname(recipe.recipe_url),
        selected_img_url: img_url,
        selected_ingredients: recipe.ingredients,
        selected_measurements: recipe.measurements
      });
    }
  }

  afterOpenModal() {
    // references are now sync'd and can be accessed.
    this.subtitle.style.color = 'red'; // '#f00';
    this.subtitle.style.paddingTop = '1.5rem';
    this.subtitle.style.fontSize = '150%';
  }

  closeModal() {
    this.setState({modalIsOpen: false});
  }

  addToFavorites(recipe_machine_name) {
    const { userModified } = this.state;

    if (userModified.favorites.includes(recipe_machine_name)) {
      const index = userModified.favorites.indexOf(recipe_machine_name);
      userModified.favorites.splice(index, 1);

      // remove from favorites collection:
      this.props.dispatch(cocktailActions.addRemoveFavoritesCollection(userModified.email, recipe_machine_name, false));

    } else {
      userModified.favorites = userModified.favorites.concat(recipe_machine_name);

      // add from favorites collection:
      this.props.dispatch(cocktailActions.addRemoveFavoritesCollection(userModified.email, recipe_machine_name, true));
    }

    let userModifiedNew = {
      ...userModified,
      ['favorites']: userModified.favorites
    };

    this.setState({
      selectedRecipeItem: recipe_machine_name,
      userModified: userModifiedNew,
      submitted: true
    });

    const { dispatch } = this.props;
    dispatch(userActions.update(userModifiedNew, false));

    this.setState({modalIsOpen: false});
  }
  // end modal

  clearFeaturedIngredients(userModified) {
    //const {  } = this.state;

    let user = {
      ...userModified,
      ['keyIngredients']: []
    };

    const {dispatch} = this.props;
    dispatch(userActions.update(user, false));
    dispatch(cocktailActions.getMyRecipes(user.cabinet, user.keyIngredients));
  }

  getRandomColor() {
    var letters = '0123456789abcdef';
    var color = '#';
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  render() {
    const { user, loggedIn, ingredients, my_recipes, alert, dispatch } = this.props;
    const { userModified, storeShelves } = this.state;

    let sweetCocktails = new Array();
    let bitterCocktails = new Array();
    let strongCocktails = new Array();
    let creamyCocktails = new Array();
    let frozenCocktails = new Array();
    let otherCocktails = new Array();
    let countCategories = 5;

    if (my_recipes.items) {

      let shoppingList = [];
      let SweetAdd = 0, StrongAdd = 0, CreamyAdd = 0, BitterAdd = 0, FrozenAdd = 0;
      for (let i = 0; i < my_recipes.items.length; i++) {

        if (userModified.favorites && userModified.favorites.includes(my_recipes.items[i].machine_name)) {
          my_recipes.items[i].favorite = true;
          for (var j = 0, len = my_recipes.items[i].missing.length; j < len; j++) {
            if (!shoppingList.includes(my_recipes.items[i].missing[j])) {
              shoppingList.push(my_recipes.items[i].missing[j]);
            }
          }
        } else {
          my_recipes.items[i].favorite = false;
        }
        switch (my_recipes.items[i].category) {
          case 'Sweet':
            sweetCocktails.push(my_recipes.items[i]);
            SweetAdd = 1;
            break;
          case 'Strong':
            strongCocktails.push(my_recipes.items[i]);
            StrongAdd = 1;
            break;
          case 'Creamy':
            creamyCocktails.push(my_recipes.items[i]);
            CreamyAdd = 1;
            break;
          case 'Bitter':
            bitterCocktails.push(my_recipes.items[i]);
            BitterAdd = 1;
            break;
          case 'Frozen':
            frozenCocktails.push(my_recipes.items[i]);
            FrozenAdd = 1;
            break;
          case 'Other':
            otherCocktails.push(my_recipes.items[i]);
            break;
        }
      }
      countCategories = SweetAdd + StrongAdd + CreamyAdd + BitterAdd + FrozenAdd;
      this.state.shoppingList = shoppingList;
    }

    let liquorStore = new Array();
    let groceryStore = new Array();
    if (storeShelves) {
      for (let i = 0; i < storeShelves.length; i++) {
        switch (storeShelves[i].category) {
          case 'Liquor':
          case 'Liqueur':
          case 'Wine':
            liquorStore.push(storeShelves[i]);
            break;
          default:
            groceryStore.push(storeShelves[i]);
        }
      }
    }

    String.prototype.capitalize = function() {
      return this.charAt(0).toUpperCase() + this.slice(1);
    }

    const parent  = { width: `${(this.state.selected_ingredients * 55) - 1}px`, height: '20rem', whiteSpace: 'nowrap' }
    let tabCt = 0;

    if (alert.addToBarMessage) {
      setTimeout(function(){
        dispatch(alertActions.addToBarClear());
      }, 5000)
    }


    // prepare modal ingredient graphic
    let measurement_reversed = [];
    let ingredients_reverse = [];
    let fullAmount = 0;
    let runningTotal = 0;
    let randomColor = '';
if (this.state.selected_measurements) {
  measurement_reversed = this.state.selected_measurements.slice().reverse();
  ingredients_reverse = this.state.selected_ingredients.slice().reverse();

  function getSum(total, num) {
    return total + num;
  }

  fullAmount = measurement_reversed.reduce(getSum);
}
    // end prepare modal ingredient graphic

    return (
      <div>

        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal"
        >
        <section style={{ height: '100%', boxSizing: 'border-box', margin: '0 auto', background: 'white', position: 'relative'}}>
          {ingredients_reverse.map((this_recipe_ingredient, ingred_index) =>
              <div key={ingred_index} class="full-width-borders" style={{backgroundColor: randomColor = this.getRandomColor(), borderLeft: '600rem solid ' + randomColor, borderRight: '600rem solid ' + randomColor, top: ((((runningTotal += measurement_reversed[ingred_index]) - measurement_reversed[ingred_index]) / fullAmount) * 100) + "%", height: (measurement_reversed[ingred_index] / fullAmount * 100) + "%" }}><div style={{marginLeft: '1rem', color: ( ((randomColor.split("e").length - 1) + (randomColor.split("f").length - 1)) > 1 ? 'black' : 'white') }}>{this_recipe_ingredient.replace(/_/g, ' ')}</div></div>
          )}
        
        <section style={{ height: '100%', boxSizing: 'border-box', margin: '0 auto', width: '50rem', background: 'white', position: 'relative'}}>
          <div className="text-center current-cocktail" style={{margin: '0 auto'}}>


            <h2 style={{color: 'rgb(255, 0, 0)'}} ref={subtitle => this.subtitle = subtitle}>{this.state.selected_name}</h2>

            <div style={{display: 'flex', justifyContent: 'space-around' }}>
              <div style={{width: '190px', height: '100%', padding: '20px'}}>

{/*<strong>{JSON.stringify(this.state.selected_ingredients)}</strong>*/}
Recipe:
                <table className="ingredient-table">
                  <tr><th>US</th><th>Metric</th><th>Ingredient</th></tr>
                {this.state.selected_ingredients && this.state.selected_ingredients.map((this_recipe_measurement, meas_index) =>
                <IngredientRow meas_index={meas_index} machine_name={this_recipe_measurement} selected_measurements={this.state.selected_measurements} ingredients={ingredients}/>
                )}
                </table>
                {this.state.userModified.favorites && !this.state.userModified.favorites.includes(this.state.selected_machine_name) &&
                <button style={{width: '100%', color: '#39739d',
    backgroundColor: '#E1ECF4',
    borderColor: '#96bdd9',
    boxShadow: 'inset 0 1px 0 #f4f8fb',
     position: 'relative', display: 'flex',
justifyContent: 'center',
alignItems: 'center', height: '55px', marginTop: '2rem'}} onClick={() => this.addToFavorites(this.state.selected_machine_name)}><img
                  src="https://www.fasttrackracingteam.com/IMAGES/INGREDIENTS/GRAPHIC_favorite.ico" style={{width: '50px', height: '50px', position: 'absolute', left: '0px'}}/>
                  <span>Add To<br/>Favorites</span><img src="https://www.fasttrackracingteam.com/IMAGES/INGREDIENTS/GRAPHIC_favorite.ico" style={{width: '50px', position: 'absolute', right: '0px'}}/></button>
                }
                {this.state.userModified.favorites && this.state.userModified.favorites.includes(this.state.selected_machine_name) &&
                <div style={{marginTop: '2rem'}}><strong>One your favorites!</strong>
                  <button style={{width: '100%', color: '#39739d',
    backgroundColor: '#E1ECF4',
    borderColor: '#96bdd9',
    boxShadow: 'inset 0 1px 0 #f4f8fb'}} onClick={() => this.addToFavorites(this.state.selected_machine_name)}>Remove From Favorites</button>
                </div>
                }

                <a className={'btn btn-info'} style={{marginTop: '2rem'}} target="_blank" href={this.state.selected_url}>View recipe on<br/>{this.state.selected_domain}</a>

              </div>
              <div style={{ paddingLeft: '20px'}}><img src={this.state.selected_img_url}/></div>
            </div>
            {ingredients.items && this.state.selected_ingredients &&
            <div style={parent}>
              {this.state.selected_ingredients.map((myIngredient, index) =>
                <IngredientSlide key={myIngredient} noLink match={myIngredient} ingredients={ingredients} youGotThis={this.state.userModified.cabinet && this.state.userModified.cabinet.includes(myIngredient)}/>
              )}
            </div>
            }
            {user.access_level > 5 &&
            <div><NavLink to={`/recipe/${this.state.selected_machine_name}`}>View details</NavLink></div>
            }

            <button style={{width: '100%', height: '4rem', marginTop: '.5rem'}} onClick={this.closeModal}>Close</button>

          </div>
          </section>
          </section>
        </Modal>


        {this.state.userModified.first_name != 'Guest' &&
        <h1 style={{display: 'none'}}>Hi {this.state.userModified.first_name}</h1>
        }

        {(!my_recipes || !my_recipes.items || !my_recipes.items.length) && (!this.state.userModified.keyIngredients || !this.state.userModified.keyIngredients.length) &&
        <div>
          <h1>Add bottles to your Bar to see what drinks you can make.</h1>
        </div>
        }

        {my_recipes.loading &&
          <div style={{height: "300px"}}>
        <Spinner />
            </div>
        }

        {!(!this.state.userModified.keyIngredients || !this.state.userModified.keyIngredients.length) && (!my_recipes || !my_recipes.items || !my_recipes.items.length) &&
        <div>
          {/*<div className="container" id="user_cabinet">
           {ingredients.loading && <em>Loading ingredients...</em>}
           {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
           {ingredients.items && this.state.userModified.keyIngredients &&
           <div className="margin-bottom" style={{ overflow: 'auto', whiteSpace: 'nowrap'}}>
           {this.state.userModified.keyIngredients.map((myIngredient, index) =>
           <IngredientName key={myIngredient} match={myIngredient} ingredients={ingredients}/>
           )}
           </div>
           }
           </div>*/}

          <div className={'alert alert-danger'}><h4>No cocktails contain all your selected <strong>Key Ingredients</strong>!</h4>
            To continue, clear some or all of your <strong>Key Ingredient</strong> designations.
          </div>

          <p>
            <button style={{fontSize: '150%'}} onClick={() => { this.clearFeaturedIngredients(userModified) }}>Clear Key Ingredient{this.state.userModified.keyIngredients.length > 1?'s':''}</button>
          </p>

        </div>
        }

        {!(!my_recipes || !my_recipes.items || !my_recipes.items.length) &&
        <div>
          {(!this.state.userModified.keyIngredients || !this.state.userModified.keyIngredients.length) &&
          <h1 style={{display: 'inline-block'}}>{my_recipes.items.length} Cocktails With Your Ingredients</h1>
          }
          {!(!this.state.userModified.keyIngredients || !this.state.userModified.keyIngredients.length) &&
          <div><h1>Cocktails with
            {this.state.userModified.keyIngredients.map((myIngredient, index) =>
              <IngredientName key={myIngredient} machine_name={myIngredient} ingredients={ingredients} secondLast={(index + 2) === this.state.userModified.keyIngredients.length} last={(index + 1) === this.state.userModified.keyIngredients.length}/>
            )}:</h1>
            <p>
              <button style={{fontSize: '150%'}} onClick={() => { this.clearFeaturedIngredients(userModified) }}>Clear Key Ingredient{this.state.userModified.keyIngredients.length > 1?'s':''}</button>
            </p>
          </div>
          }

          <Tabs style={{position: 'relative',
    overflow: 'hidden',
    margin: '0 auto',
    width: '100%',
    marginBottom: '1.2rem',
    fontWeight: 300
    }}>
            <nav className={`categories-${countCategories}`}>
              <TabList style={{fontSize: '1.25em'}}>
                {sweetCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-home"><span>Sweet</span></a></Tab>
                }
                {strongCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-box"><span>Strong</span></a></Tab>
                }
                {creamyCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-display"><span>Creamy</span></a></Tab>
                }
                {bitterCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-upload"><span>Bitter</span></a></Tab>
                }
                {frozenCocktails.length > 0 && ++tabCt > 0 &&
                <Tab><a href={`#section-linemove-${tabCt}`} class="icon icon-tools"><span>Frozen</span></a></Tab>
                }
              </TabList>
            </nav>


            {sweetCocktails.length > 0 &&
            <TabPanel>
              {my_recipes.error && <span className="text-danger">ERROR: {my_recipes.error}</span>}
              {sweetCocktails &&
              <RecipeCategory cocktailCategory={sweetCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
            {strongCocktails.length > 0 &&
            <TabPanel>

              {strongCocktails &&
              <RecipeCategory cocktailCategory={strongCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
            {creamyCocktails.length > 0 &&
            <TabPanel>
              {creamyCocktails &&
              <RecipeCategory cocktailCategory={creamyCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
            {bitterCocktails.length > 0 &&
            <TabPanel>
              {bitterCocktails &&
              <RecipeCategory cocktailCategory={bitterCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
            {frozenCocktails.length > 0 &&
            <TabPanel>
              {frozenCocktails &&
              <RecipeCategory cocktailCategory={frozenCocktails}
                              favorites={this.state.userModified.favorites ? this.state.userModified.favorites : []}
                              openModal={this.openModal}/>
              }
            </TabPanel>
            }
          </Tabs>
        </div>
        }

        {!(!this.state.shoppingList || !this.state.shoppingList.length) &&
        <div>
          <h2 style={{display: 'inline-block'}}>Shopping List</h2>  <span>(ingredients you need to fix your favorite drinks)</span>
          <div className="container" id="user_cabinet">
            {ingredients.loading && <em>Loading ingredients...</em>}
            {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
            {ingredients.items && this.state.shoppingList &&
            <div className="margin-bottom" style={{ overflow: 'auto', whiteSpace: 'nowrap'}}>
              {this.state.shoppingList.map((myIngredient, index) =>
                <IngredientSlide key={myIngredient} match={myIngredient} ingredients={ingredients} shoppingList={true}/>
              )}
            </div>
            }
          </div>
        </div>
        }

        {alert.addToBarMessage &&
        <div className={`alert ${alert.type}`}>{alert.addToBarMessage}</div>
        }
        {!(!this.state.userModified.cabinet || !this.state.userModified.cabinet.length) &&
        <div>
          <h2>Your Bar</h2> (click on bottle to designate it as a Key Ingredient)
          <div className="container" id="user_cabinet">
            {ingredients.loading && <em>Loading ingredients...</em>}
            {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
            {ingredients.items && this.state.userModified.cabinet &&
            <div className="margin-bottom" style={{ overflow: 'auto', whiteSpace: 'nowrap'}}>
              {this.state.userModified.cabinet.map((myIngredient, index) =>
                <IngredientSlide key={myIngredient} displayBorder={this.state.userModified.keyIngredients.includes(myIngredient)} match={myIngredient} ingredients={ingredients} showCabinetRemove={true}/>
              )}
            </div>
            }
          </div>
        </div>
        }

        <h2 style={{display: 'inline-block'}}>Ingredients</h2> (click on bottle to add it to your bar)
        {ingredients.loading && <em>Loading ingredients...</em>}
        {ingredients.error && <span className="text-danger">ERROR: {ingredients.error}</span>}
        <h3>Liquor Store</h3>
        {liquorStore &&
        <div className="margin-bottom" style={{ overflow: 'auto', whiteSpace: 'nowrap'}}>
          {liquorStore.map((thisIngredient, index) =>

            <div onClick={() => { this.onItemClick(thisIngredient.machine_name) }} style={{background: `url(${thisIngredient.img_url}) no-repeat center/cover`, position: 'relative', whiteSpace: 'normal', display: 'inline-block', height: `20rem`, cursor: 'pointer', width: '55px'}}>
              <div style={{background: 'rgba(0, 0, 0, 0.5)', color: 'white', padding: '5px', bottom: '0px', position: 'absolute', width: '100%', boxSizing: 'border-box'}}>{thisIngredient.name}</div>
            </div>
          )
          }
        </div>
        }
        <h3>Grocery Store</h3>
        {groceryStore &&
        <div className="margin-bottom" style={{ overflow: 'auto', whiteSpace: 'nowrap'}}>
          {groceryStore.map((thisIngredient, index) =>

            <div onClick={() => { this.onItemClick(thisIngredient.machine_name) }} style={{background: `url(${thisIngredient.img_url}) no-repeat center/cover`, position: 'relative', whiteSpace: 'normal', display: 'inline-block', height: `20rem`, cursor: 'pointer', width: '55px'}}>
              <div style={{background: 'rgba(0, 0, 0, 0.5)', color: 'white', padding: '5px', bottom: '0px', position: 'absolute', width: '100%', boxSizing: 'border-box'}}>{thisIngredient.name}</div>
            </div>
          )
          }
        </div>
        }

        {loggedIn && !(!this.state.userModified.cabinet || !this.state.userModified.cabinet.length) &&
        <p>
          <ConfirmClearData user={user} />
          {/*<Link to="/login">Logout</Link>*/}
        </p>
        }
      </div>
    );
  }
}
// https://storage.googleapis.com/coverflow-react/index.html

function mapStateToProps(state) {
  const { authentication, my_recipes, ingredients, alert } = state;
  const { user, loggedIn } = authentication;
  return {
    user,
    loggedIn,
    my_recipes,
    ingredients,
    alert
  };
}

const connectedHomePage = connect(mapStateToProps)(HomePage);
export { connectedHomePage as HomePage };


// WEBPACK FOOTER //
// ./src/HomePage/HomePage.jsx